import { Fragment } from 'react';

type Props<T> = {
  posts: T[];
  firstOneIsHeroPost?: boolean;
  render: (
    post: NonNullable<T>,
    isHeroPost: boolean
  ) => React.ReactElement<any>;
  insertions?: {
    position: number;
    render: () => React.ReactElement<any>;
  }[];
};

export const PostList: <T extends { slug?: string | null | undefined } = any>(
  props: Props<T>
) => React.ReactElement<Props<T>> = ({
  posts,
  firstOneIsHeroPost,
  render,
  insertions,
}) => (
  <section>
    <div className='grid grid-cols-1 gap-8 md:mb-32 md:grid-cols-2'>
      {posts.map((post, i) => (
        <Fragment key={post.slug || i}>
          {insertions?.find((e) => e.position === i)?.render()}
          {post && render(post!, !!firstOneIsHeroPost && i === 0)}
        </Fragment>
      ))}
    </div>
  </section>
);
